const { Core, Events, DOMEvents, Utils } = Global;
const { $state } = Utils;

customElements.define('cart-variant-selector-modal-min-product', class extends Core {
    elements = {
        modal: 'modal-container'
    }

    propTypes = {
        'old-key': String,
        'old-line-index': Number,
        'quantity': Number
    };

    render() {
        this.$({ change: this._publishChange });
        this.$('modal', {'modal-close': this._handleClose } );
    }

    _publishChange(e) {
        e.stopPropagation();
        e.preventDefault();

        var prodId = e.target.getAttribute('data-product-id');
        var variantId = e.target.value;
        var variantImg = e.target.getAttribute('data-variant-img');
        var variantTitle = e.target.getAttribute('data-variant-title');
        
        // --- START: Added SKU and Price data ---
        var variantSku = e.target.getAttribute('data-variant-sku');
        var variantPrice = e.target.getAttribute('data-variant-price');
        // --- END: Added SKU and Price data ---

        var currentProduct = document.querySelector('.\\#product-card-min[data-product-id="' + prodId + '"]');
        if (currentProduct != null) {
          var currentProductToCart = currentProduct.querySelector('product-to-cart');
          var currentProductImage = currentProduct.querySelector('.\\#media-image');
          var currentProductOptValue = currentProduct.querySelector('.\\#product-card-min-info-option-value');
          
          // --- START: Find SKU and Price elements ---
          var currentProductSku = currentProduct.querySelector('.\\#product-card-min-sku');
          var currentProductPrice = currentProduct.querySelector('.\\#product-card-min-price.wsgAjaxPrice');
          // --- END: Find SKU and Price elements ---

          if (currentProductToCart != null) {
            currentProductToCart.setAttribute('variant-id', variantId);
          }

          if (currentProductImage != null) {
            currentProductImage.setAttribute('src', variantImg);
            currentProductImage.removeAttribute('srcset');
          }

          if (currentProductOptValue != null) {
            currentProductOptValue.innerHTML = variantTitle;
          }
          
          // --- START: Update SKU and Price HTML ---
          if (currentProductPrice != null) {
            currentProductPrice.innerHTML = variantPrice;
          }

          if (currentProductSku != null) {
            if (variantSku && variantSku.length > 0) {
              currentProductSku.innerHTML = 'SKU: ' + variantSku;
            } else {
              // Add a non-breaking space to prevent layout collapse
              currentProductSku.innerHTML = '&nbsp;';
            }
          }
          // --- END: Update SKU and Price HTML ---
        }
      
        this.$('modal').close();
    }
    
    _handleClose(e) {
        e.stopPropagation();
    }
})